/** Method key for the `@around` hook that reflects `disabled` state onto `internals.states` (see `disabled.ts`). */
export const disableable = Symbol('disableable')
/** Method key for the `@formDisabled` hook that mirrors a `<fieldset disabled>` onto the element (see `disabled.ts`). */
export const inherit = Symbol('inherit')
